module.exports = __webpack_public_path__ + "img/eqc-story.b9968ce9.jpg";